import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';

import Loading from 'zignal-landscape/lib/Loading';
import EmptyTable from './components/EmptyTable';

const TableLoader = ({
  styles,
  loading = false,
  items = [],
  emptyTableProps = null,
  children
}) => {
  return (
    <div className={styles.TableLoader}>
      {loading && !items.length ? <Loading /> : children}
      {!loading && !items.length && emptyTableProps && <EmptyTable {...emptyTableProps} />}
    </div>
  );
};

TableLoader.propTypes = {
  styles: PropTypes.object,
  loading: PropTypes.bool,
  items: PropTypes.array,
  emptyTableProps: PropTypes.object,
  children: PropTypes.node
};

export default themeable(TableLoader);
